<!-- Full-page login on the BUI brand surface (Phase 3). Deliberately a page,
     not a modal. Input ids/names are kept for browser autofill. -->

<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="auth-card__header">
        <img class="logo" src="/src/assets/images/bitshuttle.png" alt="bitSHUTTLE logo" />
      </div>
      <div class="auth-card__body" @keyup="keyPressHandler">
        <h1 class="auth-title">Log In</h1>
        <StatusBar
          :errorMessage="user.error"
          :isLoading="user.isLoading"
          loadingMessage="Logging in..."
        />
        <input
          class="auth-input"
          data-val="true"
          data-val-required="The User name field is required."
          id="userName"
          name="userName"
          placeholder="Username"
          type="text"
          v-model.lazy="username"
        />
        <input
          class="auth-input"
          data-val="true"
          data-val-required="The Password field is required."
          id="password"
          name="password"
          placeholder="Password"
          type="password"
          v-model.lazy="password"
        />
        <label class="auth-check" for="rememberMe">
          <input
            data-val="true"
            data-val-required="The Remember me? field is required."
            id="rememberMe"
            name="rememberMe"
            type="checkbox"
            value="true"
          />
          <input name="rememberMe" type="hidden" value="false" />
          Remember me?
        </label>
        <button type="button" @click="submit" class="auth-btn">Log In</button>
        <button type="button" @click="submitPasswordResetRequest" class="auth-link">Forgot password?</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watchEffect } from 'vue';
import useUserStore from '@/stores/user';
import router from '@/router';
import StatusBar from '@/components/form-fields/StatusBar/StatusBar.vue';
import { sendPasswordResetEmail } from '@/helpers/api/user';

const user = useUserStore();
const username = ref("");
const password = ref("");

async function submit() {
  await user.login({username:username.value, password: password.value});
}
watchEffect(() => {
  if(user.isLoggedIn == true) {
    router.push({ name: 'home' })
  }
})

async function submitPasswordResetRequest() {
  try {
    // // check if username is empty or not an email
    const emailValidateRegex = /^(?!\.)[A-Za-z0-9._%+-]+(?<!\.)@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?<!\.)$/;
    if (username.value === '' || !emailValidateRegex.test(username.value)) {
      user.passwordResetErrorMessage = 'The Username field is invalid.';
      router.push({ name: 'reset-password', query: { userRequestingResetPassword: username.value, isResendSuccess: "false" } });
      return;
    }
    await sendPasswordResetEmail(username.value);
    router.push({ name: 'reset-password', query: { userRequestingResetPassword: username.value, isResendSuccess: "true" } });
  } catch (error:any) {
    console.error('handleSendPasswordResetEmail', error);
    router.push({ name: 'reset-password', query: { userRequestingResetPassword: username.value, isResendSuccess: "false" } });
    user.passwordResetErrorMessage = error?.message || "";
  }
}

function keyPressHandler(e) {
  if (e.key === 'Enter') {
    submit();
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/bui-auth-page';
</style>
